import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import messages from '../../../services/messages'

import {
  getInteractions,
  setInteractions,
  apiError,
} from '../../../redux/interactions/actions'

import { useTranslation } from 'react-i18next'
import BalloonSystem from '../../atoms/balloons/balloonSystem'
import BalloonConsumer from '../../atoms/balloons/balloonConsumer'
import BalloonAgent from '../../atoms/balloons/balloonAgent'
import BalloonTabs from '../../atoms/balloons/ballonTabs'

import useStyles from './insteractionsStyle'
import { Card } from '@material-ui/core'
import Typography from '../../atoms/display/typography'
import CircularProgress from '../../atoms/feedback/circularProgress'
import NoteComponent from './noteComponent'
import { useTheme } from '@material-ui/core/styles'
import moment from 'moment'
import 'moment/locale/pt'
import { getSender } from '../../../utils/messages'

function InteractionsComponent() {
  const dispatch = useDispatch()
  const { t , i18n} = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const user = useSelector((state) => state.user)

  const chatId = useSelector((state) => state.activeConversation)
  const interactions = useSelector((state) => state.interactions.data?.[chatId])
  const userList = useSelector((state) => state.interactions.userList?.[chatId])
  const status = useSelector((state) => state.interactions.status?.[chatId])
  const conversation = useSelector(
    (state) => state.conversations.conversations[chatId]
  )
  const [languageMoment, setLanguageMoment] = useState(null)

  const handleRefresh = async () => {
    if (!chatId) return
    dispatch(getInteractions(chatId))
    try {
      const response = await messages.get(
        `/tech4h-messages/interaction/${chatId}`
      )
      if (response.status === 200) {
        dispatch(setInteractions(chatId, response.data.data))
      } else {
        throw response
      }
    } catch (error) {
      const message = t('alerts.reloadWidgetInfo')
      dispatch(apiError(chatId, message))
    }
  }

  useEffect(() => {
    if (!chatId) return
    handleRefresh()
  }, [chatId])

  useEffect(()=>{
    if(i18n.language === "eng"){
      setLanguageMoment("en-us")
    }else if(i18n.language === "pt"){
      setLanguageMoment("pt-br")
    }
  },[t])

  const renderBallonBySenderType = (el) => {
    if (!el.text && !el.private_note_operator) return <></>

    if (el.by === 'system' || el.by === 'bot') {
      return <BalloonSystem data={el} resize />
    }
    if (el.by === 'consumer') {
      el.files = el.filesConsumer
      return <BalloonConsumer data={el} resize />
    }
  }

  const renderNote = (el, isPrivate) => {
    if (el?.by === 'consumer') {
      return <></>
    }
    return (
      <NoteComponent
        element={el}
        privateText={isPrivate}
        userList={userList}
      ></NoteComponent>
    )
  }

  /**
   * Function that renders the agent name and the date of each
   * tabulation made by each respective agent.
   * @param {object} element
   * @returns {JSX.Element}
   */
  const renderAgentNameAndDate = useCallback(
    (element) => {
      moment.locale(languageMoment)
      return (
        <>
          <div
            className={classes.header}
            style={{
              color: theme.palette.type !== 'dark' && '#286796',
            }}
          >
            <span
              style={{
                marginRight: 6,
              }}
            >
              {moment(element?.sentTime).format('D MMMM YYYY | HH:mm:ss')}
            </span>
            <span>
              {element?.userId == undefined ? "" : getSender(element, userList ?? conversation?.users) ??
                user?.name }
            </span>
          </div>
        </>
      )
    },
    [getSender, conversation, userList, user, languageMoment, theme]
  )

  return (
    <Card className={classes.content}>
      {interactions?.map((el, key) => (
        <>
          <div key={key}>
            {el?.by !== 'consumer' && <BalloonTabs data={el} resize />}
            {el?.private_note_operator && renderNote(el, true)}
            {(el?.text ||
              (Array.isArray(el?.filesOperator) &&
                el?.filesOperator?.length > 0)) &&
              renderNote(el, false)}
            {renderBallonBySenderType(el)}
            {el?.by !== 'consumer' && renderAgentNameAndDate(el)}
          </div>
        </>
      ))}

      {!interactions?.length && !status?.loading && (
        <div className={classes.content}>
          {status?.error ? (
            <Typography variant="h6">{t(status.error)}</Typography>
          ) : (
            <Typography variant="h6">
              {t('commons.searchResultEmpty')}
            </Typography>
          )}
        </div>
      )}
      {!interactions?.length && status?.loading && (
        <div className={classes.content}>
          <CircularProgress
            style={{
              margin: 'auto',
            }}
          />
        </div>
      )}
    </Card>
  )
}

export default memo(InteractionsComponent)
